import { BASE_URL } from '@/utils/Constants';
import { useAuth } from '@/utils/stores/useAuthStore';
import { useMutation } from '@tanstack/react-query';

export const deleteDocument = async (id: string, token: string) => {
  const response = await fetch(`${BASE_URL}/api/documents/${id}`, {
    method: 'DELETE',
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error('Failed to delete document');
  }
  return response.json();
};

export const useDeleteDocument = (id: string) => {
  const { idToken } = useAuth();
  const { mutate, isPending, error, isSuccess, data } = useMutation({
    mutationFn: () => deleteDocument(id, idToken!),
  });
  return { mutate, isPending, error, isSuccess, data };
};
